<template lang="pug">
.options
	.backdrop
	.content
		.close(@click="close") ×
		.title
			NewTranslation(path="benefitsDetail.coupon.overlay.title")
		.description Sie erhalten ein Freigetränk zum Burger-Menü.
		Button(color="green" @click.native="redeem").button
			NewTranslation(path="benefitsDetail.coupon.overlay.btn.redeem")
			font-awesome-icon(icon="chevron-right" slot="icon" style="padding-left: 2px")
		Button(color="gray" @click.native="close" center).button
			NewTranslation(path="benefitsDetail.coupon.overlay.btn.close")
</template>

<script>
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';

export default {
  components: {
    NewTranslation,
    Button,
  },
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
    redeem() {
      this.$store.commit('openOverlay', 'CouponDetail');
    },
  },
};
</script>

<style lang="sass" scoped>
.options
	width: 100%
	height: 100vh
	display: flex
	flex-direction: column
	align-items: center
	justify-content: center
	position: fixed
	max-width: 480px
	margin: 0 auto
	right: 0
	top: 0
	left: 0
	z-index: 9
.backdrop
	background-color: rgba(0, 0, 0, .8)
	width: 100%
	height: 100vh
	position: absolute
	z-index: 6
.close
	position: absolute
	right: 20px
	top: 20px
	background-color: #fff
	z-index: 9
	color: #1DB2D1
	border: 1px solid #1DB2D1
	width: 20px
	height: 20px
	display: flex
	justify-content: center
	align-items: center
	border-radius: 20px
.content
	z-index: 7
	background-color: #fff
	border-radius: 10px
	padding: 20px
	margin: 20px
	position: relative
.title
	font-size: 20px
	color: #1DB2D1
	text-align: center
.description
	text-align: center
	color: #454F63
	margin-top: 20px
.button
	margin-top: 20px
</style>
